<div [appLoading]="isLoading" class="scenario-comparison">
  <div class="scenario-comparison__header-row">
      <div class="button--cta" id="buttonAddScenario">
          <button class="zs-button zs-button-solid zs-border-rounded-0" (click)="addScenarioForComparison()">Add
              Scenario</button>
      </div>
  </div>


  <div class="scenario-comparison__scenario-table cds-bg-white">
    <div class = "warning">
    <div class = "warning">
      <label *ngIf="checkedCount < 5">Current count: {{checkedCount}}</label>
      <label *ngIf="checkedCount === 5">Only 5 combinations of deal and no deal can be selected!</label>
      <label *ngIf="checkedCount > 5">Please select max 5 combinations of deal and no deal to continue</label>
      </div>
      <table class="zs-table zs-table-condense zs-margin-2-0-0-0">
        <thead>
          <tr>
            <th>Remove</th>
            <th>Scenario Name</th>
            <th>Deal</th>
            <th *ngIf="!showAnchor">No Deal</th>
            <th>Anchor</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let scenario of scenariosToCompare; let row = index;">
            <tr>
              <td>
                <span class="zs-icon zs-size-xl zs-icon-subtract"
                      (click)="removeScenarioFromComparison(scenario.ScenarioID)">
                </span>
              </td>
              <td>{{scenario.ScenarioName}}</td>

              <!-- Deal Checkbox with handleCheckboxChange -->
              <td *ngIf="!showAnchor">
                <div class="alias-cell">
                  <span class="alias-text" [title]="scenario.dealAlias || 'Deal'">{{scenario.dealAlias || 'Deal'}}</span>
                  <label class="zs-checkbox" [ngClass]="{'zs-disabled': (checkedCount >= maxCheckedScenarios && !scenario.deal)}">
                    <input type="checkbox"
                           [(ngModel)]="scenario.deal"
                           (change)="handleCheckboxChange($event, scenario, 'deal')">
                    <span checkbox></span>
                  </label>
                </div>
              </td>
              <td *ngIf="showAnchor">
                <div class="alias-cell">
                  <span class="alias-text" [title]="scenario.dealAlias+'oo' || 'Deall'">{{scenario.dealAlias+'oo' || 'Deall'}}</span>
                  <label class="zs-checkbox">
                    <input type="checkbox"
                           [(ngModel)]="scenario.deal"
                           (change)="handleCheckboxChange($event, scenario, 'deal')">
                    <span checkbox></span>
                  </label>
                </div>
              </td>

              <!-- Anchor/No Deal Checkbox with handleCheckboxChange -->
              <td *ngIf="!showAnchor">
                <div class="alias-cell">
                  <span class="alias-text" [title]="scenario.noDealAlias || 'No Deal'">{{scenario.noDealAlias || 'No Deal'}}</span>
                  <label class="zs-checkbox" [ngClass]="{'zs-disabled': (checkedCount >= maxCheckedScenarios && !scenario.noDeal)}">
                    <input type="checkbox"
                           [(ngModel)]="scenario.noDeal"
                           (change)="handleCheckboxChange($event, scenario, 'noDeal')">
                    <span checkbox></span>
                  </label>
                </div>
              </td>
              <td>
                <label class="zs-checkbox" [ngClass]="{'zs-disabled': isCheckboxDisabled(scenario)}">
                  <input type="checkbox"
                         [(ngModel)]="scenario.anchor"
                         (change)="handleCheckboxChange($event, scenario, 'anchor')">
                  <span checkbox></span>
                </label>
              </td>

            </tr>
          </ng-container>
        </tbody>
      </table>



        <div class="button--cta" style="display: flex; justify-content: flex-end;width: 100%;">
        <button [ngClass]="{'zs-disabled': disableCompareScenariosButton()}"
                class="zs-button zs-button-solid zs-border-rounded-0"
                (click)="compareScenarios()">
            Compare Scenarios
        </button>
      </div>


    </div>

  <div *ngIf="showComparisonOutput"
      class="scenario-comparison__output-section cds-bg-white zs-width-100 zs-margin-2-0-0-0">
      <div class="filter zs-text-align-left">
          <p-is-zs-select #brandDpDwn *ngIf="productList?.length>0" class="zs-action-field zs-select" mode="action"
              hide-on-scroll label="Product:"
              (change)="selectedProductName = brandDpDwn.getValue(); fillScenarioComparisonGraph();"
              clear>
              <select>
                  <option *ngFor="let brand of productList" [value]="brand">{{brand}} </option>
              </select>
          </p-is-zs-select>
      </div>
      <div #chartContainer class="chart">
      </div>
      <div class="zs-display-flex zs-flex-justify-space-between zs-margin-1-0">
          <div class="counter-text">
            No. of selected scenarios for selected Brand and Channel : {{counterForCheckedScenariosCount}}
          </div>
          <div *ngIf="showDiv" class="copy-clipboard">
              <span>
                  <a href="javascript:void(0)" title="Copy to Clipboard"
                      (click)="copyToExcel('scenarioComparison', true)" class="zs-icon zs-size-xl zs-icon-note"></a>
                  <a href="javascript:void(0)" (click)="copyToExcel('scenarioComparison', true)">Copy</a>
              </span>
          </div>
          <!-- filter-modal -->
          <zs-dialog #filterModal class="zs-dialog modal filter-section" role="dialog" modal>
              <header>
                <h3 class="header-pcgc-toggle">Scenario Comparison
                  <div class="zs-display-inline-flex">
                    <p-is-zs-toggle class="zs-toggle-component zs-size-xxs zs-margin-0-5-0-0" [attr.active]="isPCGCSelected || undefined" (change)="selectPCGCMetrics()"></p-is-zs-toggle>
                    <span class="zs-margin-0-7-0-0">{{ filterSummaryHeaderName }} Summary</span>
                  </div>
                </h3>
                <span close="" (click)="closeFilter()">
                  <a href="javascript:void(0);" class="zs-icon zs-icon-close-circle-fill zs-size-xl"></a>
                </span>
              </header>


              <div class="filter-table-container">
                <div class="filter-table">
                  <div class="zs-display-flex zs-display-flex-direction-column">
                    <h4>Contract Financials</h4>
                    <div class="project-search-and-btn" style="margin-top:-10px;">
                      <div class="search">
                        <p-is-zs-action-field class="zs-action-field zs-action-field-solid zs-border" type="text"
                        placeholder="Search..." style="width:100%;" autocomplete="off" icon="search" action-icon="collapse" [(ngModel)]="searchTextFinancial"
                         ngDefaultControl>
                      </p-is-zs-action-field>
                      </div>
                      </div>
                  </div>
                  <table scrollY="true" class="zs-table zs-table-condense">
                    <thead>
                      <tr>
                        <th style="width: 15%;">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input type="checkbox" id="contract-select-all" (change)="selectAllMetrices($event,tempFinancialData[selectedFinancialindex].financialData,'tempFinancialData',searchTextFinancial)" [(ngModel)]="isProductSelectAllChecked"/>
                          <span checkbox></span>

                           </label>
                        </th>
                        <th>Field</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of tempFinancialData[selectedFinancialindex].financialData | search : searchTextFinancial">
                        <td *ngIf="item.Is_Submetric === 'No'">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input (change)="checkMetrics($event,item,tempFinancialData[selectedFinancialindex].financialData,'tempFinancialData')" type="checkbox" [(ngModel)]="item.isSelected" />
                          <span checkbox></span>

                        </label>

                        </td>
                        <td *ngIf="item.Is_Submetric === 'Yes'" class="zs-bg-surface-2">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input (change)="checkSubMetrics($event,item,tempFinancialData[selectedFinancialindex].financialData,'tempFinancialData')" type="checkbox" [(ngModel)]="item.isSelected" />
                          <span checkbox></span>

                        </label>

                        </td>


                          <!-- <td *ngIf="item.Is_Submetric === 'Yes'" class="zs-bg-surface-2" >  </td> -->
                          <td [ngClass]="item.Is_Submetric === 'Yes' ? 'zs-bg-surface-2' : ''">{{ item.Is_Submetric === 'Yes' ? '&nbsp; - ' : '' }} {{item.Item_Text }}</td>
                        </tr>
                    </tbody>
                  </table>
                </div>
                <div class="filter-table">
                  <div class="zs-display-flex zs-display-flex-direction-column">
                    <h4>Customer POV</h4>
                    <div class="project-search-and-btn" style="margin-top:-10px;">
                      <div class="search">
                        <p-is-zs-action-field class="zs-action-field zs-action-field-solid zs-border" type="text"
                        placeholder="Search..." style="width:100%;" autocomplete="off" icon="search" action-icon="collapse" [(ngModel)]="searchTextCustomer"
                         ngDefaultControl>
                      </p-is-zs-action-field>
                      </div>
                      </div>
                  </div>
                  <table scrollY="true" class="zs-table zs-table-condense">
                    <thead>
                      <tr>
                        <th style="width: 15%;">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input type="checkbox" id="customer-select-all" (change)="selectAllMetrices($event,tempCustomerPOVData[selectedCustomerindex].data,'tempCustomerPOVData',searchTextCustomer)" [(ngModel)]="isCustomerSelectAllChecked" />
                          <span checkbox></span>

                        </label>
                      </th>
                          <th>Field</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of tempCustomerPOVData[selectedCustomerindex].data | search : searchTextCustomer" >
                        <td *ngIf="item.Is_Submetric === 'No'">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input (change)="checkMetrics($event,item,tempCustomerPOVData[selectedCustomerindex].data,'tempCustomerPOVData')" type="checkbox"  [(ngModel)]="item.isSelected" />
                          <span checkbox></span>

                        </label>
                        </td>
                        <td *ngIf="item.Is_Submetric === 'Yes'" class="zs-bg-surface-2"> 
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input (change)="checkSubMetrics($event,item,tempCustomerPOVData[selectedCustomerindex].data,'tempCustomerPOVData')" type="checkbox"  [(ngModel)]="item.isSelected" />
                          <span checkbox></span>

                        </label>
                        </td>
                        <!-- <td *ngIf="item.Is_Submetric === 'Yes'" class="zs-bg-surface-2">  </td> -->
                        <td [ngClass]="item.Is_Submetric === 'Yes' ? 'zs-bg-surface-2' : ''">{{ item.Is_Submetric === 'Yes' ? '&nbsp; - ' : '' }} {{item.Item_Text }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="filter-table">
                  <div class="zs-display-flex zs-display-flex-direction-column">
                    <h4>Competitor POV</h4>

                    <div class="project-search-and-btn" style="margin-top:-10px;">
                      <div class="search">
                        <p-is-zs-action-field style="width:100%;" class="zs-action-field zs-action-field-solid zs-border" type="text"
                        placeholder="Search..." autocomplete="off" icon="search" action-icon="collapse" [(ngModel)]="searchTextCompetitor"
                         ngDefaultControl>
                      </p-is-zs-action-field>
                      </div>
                      </div>                  </div>
                  <table scrollY="true" class="zs-table zs-table-condense">
                    <thead>
                      <tr>
                        <th style="width: 15%;">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                          <input type="checkbox" id="competitor-select-all" (click)="selectAllMetrices($event,tempCompPOVData[selectedCompetitorIndex].data,'tempCompPOVData',searchTextCompetitor)" [(ngModel)]="isCompetitorSelectAllChecked" />
                          <span checkbox></span>
                          </label>
                          </th>
                          <th>Field</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of tempCompPOVData[selectedCompetitorIndex].data | search : searchTextCompetitor">
                        <td *ngIf="item.Is_Submetric === 'No'">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                            <input (change)="checkMetrics($event,item,tempCompPOVData[selectedCompetitorIndex].data,'tempCompPOVData')" type="checkbox" [(ngModel)]="item.isSelected" />
                            <span checkbox></span>
                          </label>
                        </td>
                        <td *ngIf="item.Is_Submetric === 'Yes'" class="zs-bg-surface-2">
                          <label class="zs-checkbox" style="padding-left:10px;padding-right:10px;" >

                            <input (change)="checkSubMetrics($event,item,tempCompPOVData[selectedCompetitorIndex].data,'tempCompPOVData')" type="checkbox" [(ngModel)]="item.isSelected" />
                            <span checkbox></span>
                          </label>
                        </td>
                        <!-- <td *ngIf="item.Is_Submetric === 'Yes'" class="zs-bg-surface-2">  </td> -->
                        <td [ngClass]="item.Is_Submetric === 'Yes' ? 'zs-bg-surface-2' : ''">{{ item.Is_Submetric === 'Yes' ? '&nbsp; - ' : '' }} {{item.Item_Text }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="modal-actions">
                <button class="zs-button zs-border-rounded-0" (click)="closeFilter()">Cancel</button>
                <button class="zs-button zs-border-rounded-0" (click)="resetFilters()">Reset</button>
                <button class="zs-button zs-button-action zs-border-rounded-0" (click)="applyFilters()">Apply</button>
              </div>
            </zs-dialog>
            <zs-dialog #ndcListModal class="zs-dialog modal filter-section" role="dialog" modal>
            <header>
              <h3 class="zs-text-align-left">Selected NDCs List</h3>
              <span (click)="closeNdcListModal()" style="position: absolute; right: 10px; top: 10px; cursor: pointer; padding: 8px;">
                <a href="javascript:;" class="zs-icon zs-icon-close-circle-fill zs-size-xl"></a>
              </span>
            </header>
            <!-- 🔹 Common Dropdown -->
            <div class="filter zs-text-align-left" style="margin-left: 20px;">
              <p-is-zs-select
                #ndcParentDpDwn
                *ngIf="ndcParentList?.length > 0"
                class="zs-action-field zs-select"
                mode="action"
                hide-on-scroll
                label="Select NDC Parent"
                [value]="selectedParent"
                (change)="selectedParent = ndcParentDpDwn.getValue()"
                clear
              >
                <select>
                  <option *ngFor="let parent of ndcParentList" [value]="parent">{{ parent }}</option>
                </select>
              </p-is-zs-select>
            </div>

          <section class="filter-table-container" style="max-width: 100%;">
            <!-- 🔹 One table per Scenario -->
            <div *ngFor="let scenario of ndcMap" class="filter-table zs-margin-bottom-3">
              <div class="zs-display-flex zs-display-flex-direction-column">
                <h4>{{ scenario.ScName }}</h4>
              </div>

              <table class="zs-table zs-table-condense" scrollY="true">
                <thead>
                  <tr>
                    <th style="width: 15%;">#</th>
                    <th>Product</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Show products matching selectedParent -->
                  <tr *ngFor="let product of getFilteredProducts(scenario); let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ product.Product }}</td>
                  </tr>

                  <!-- Empty state -->
                  <tr *ngIf="getFilteredProducts(scenario).length === 0">
                    <td colspan="2" class="zs-text-align-center zs-text-muted">
                      No products for selected parent in this scenario.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          </zs-dialog>
      </div>
      <div *ngIf="showDiv" class="scenario-comparison__calculation-table zs-padding-0-0-2-0">
          <table class="zs-table zs-table-condense">
              <thead>
                  <tr>
                      <th>Scenario Name</th>
                      <th>Total Scenario Net Sales</th>
                      <th>Delta Scenario Net Sales (Compared to Anchor)</th>
                      <th>ROC (Compared to respective No Deal)</th>
                      <th>Exit Share %</th>
                      <th>Discretionary Rebate %</th>
                      <th>Total Rebate %</th>
                  </tr>
              </thead>
              <tbody>
                  <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
                      <tr mark *ngIf="row == 0">
                          <td><a href="javascript:void(0)"
                                  (click)=openScenario(scenario.ScenarioId)>{{scenario.ScenarioName}} - No Deal</a>
                          </td>
                          <td>{{scenario.NetSales | currency:"$"}}</td>
                          <td>{{scenario.DeltaNetSales}}</td>
                          <td>{{scenario.ROC}}</td>
                          <td>{{scenario.ExitShare/100 | percent: '1.2-2'}}</td>
                          <td>{{scenario.DiscretionaryRebates/100 | percent: '1.2-2'}}</td>
                          <td>{{scenario.TotalRebate/100 | percent: '1.2-2'}}</td>
                      </tr>
                  </ng-container>
                  <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
                      <tr *ngIf="row != 0">
                          <td><a href="javascript:void(0)"
                                  (click)=openScenario(scenario.ScenarioId)>{{scenario.ScenarioName}} - Deal</a></td>
                          <td>{{scenario.NetSales | currency:"$"}}</td>
                          <td>{{scenario.DeltaNetSales | currency:"$"}}</td>
                          <td>{{scenario.ROC}}</td>
                          <td>{{scenario.ExitShare/100 | percent: '1.2-2'}}</td>
                          <td>{{scenario.DiscretionaryRebates/100 | percent: '1.2-2'}}</td>
                          <td>{{scenario.TotalRebate/100 | percent: '1.2-2'}}</td>
                      </tr>
                  </ng-container>
              </tbody>
          </table>
      </div>
      <!-- my code new section  -->
       <!-- Drop Down for Time Period -->
       <div style="display: flex;">
        <div class="filter zs-text-align-left" style="margin-right: 20px;">
            <p-is-zs-select #timePeriodDpDwn *ngIf="povCommonDdbSummary.timeCategory.options?.length > 0 && TimePerioddropdownVisible" class="zs-action-field zs-select"
              mode="action" hide-on-scroll label="Select Time Period"
                [value]="povCommonDdbSummary.timeCategory.selected"
                (change)="povCommonDdbSummary.timeCategory.selected = timePeriodDpDwn.getValue(); setSelectedYearVal();"
              clear>
              <select>
                <option *ngFor="let option of povCommonDdbSummary.timeCategory.options" [value]="option">{{option}}
                </option>
              </select>
            </p-is-zs-select>
          </div>
          <div class="filter zs-text-align-left" style="margin-right: 20px;">
            <p-is-zs-select #CalenderYearDpDwn *ngIf="calenderYears.timeCategory.options?.length > 0 && povCommonDdbSummary.timeCategory.selected =='Calendar Year'" class="zs-action-field zs-select"
              mode="action" hide-on-scroll label="Select Year"
              [value]="calenderYears.timeCategory.selected"
              (change)="selectedyear = CalenderYearDpDwn.getValue();"
              clear>
              <select>
                <option *ngFor="let option of calenderYears.timeCategory.options" [value]="option">{{option}}
                </option>
              </select>
            </p-is-zs-select>
          </div>
       </div>
      <!-- Contract Details  -->
      <div>
        <div *ngIf="!showDiv" class="contract-details-container">
        <span class="contract-details-header">Contract Details</span>
        <div>
          <span *ngIf="ndcMap.length>0" style="margin-right: 25px;">     
            <a href="javascript:void(0)" (click)="openNdcListModal()">Selected NDCs List</a>
          </span>
        <span style="margin-right: 25px;">
          <a class="zs-icon zs-icon-filter zs-size-xxl" (click)="openFilter()"></a>
          <a href="javascript:void(0)" (click)="openFilter()">Filter</a>
        </span>
        </div>
        </div>
        <div *ngIf="!showDiv" class="zs-display-flex zs-margin-1-0"
          style="display: flex; justify-content: normal; align-items: center; ">
          <!--Dropdown and Copy for Contract Details -->
          <div class="filter zs-text-align-left" style="margin-right: 20px;">
            <p-is-zs-select #ContractDetailsDpDwn *ngIf="contractProdList?.length > 0" class="zs-action-field zs-select"
              mode="action" hide-on-scroll label="Selected Product"
              (change)="selectedContractProductName = ContractDetailsDpDwn.getValue(); getContractindex(selectedContractProductName);"
              clear>
              <select>
                <option *ngFor="let contractProduct of contractProdList" [value]="contractProduct">{{contractProduct}}
                </option>
              </select>
            </p-is-zs-select>
          </div>
          <div class="bordered1" style="display: flex; align-items: center; flex-wrap: nowrap; gap: 1rem; margin-right: auto;">
          
            <label class="zs-radio"  style="display: flex; align-items: center;">
              <input type="radio" name="contractDetailsValueFormat" [(ngModel)]="selectedContractDetailsMultiplier" [value]="1">
              <span radio style="padding-right: 1rem;">Actuals</span>
            </label>
            <label class="zs-radio" style="display: flex; align-items: center;">
              <input type="radio" name="contractDetailsValueFormat" [(ngModel)]="selectedContractDetailsMultiplier" [value]="1000">
              <span radio style="padding-right: 1rem;">Thousands</span>
            </label>
            <label class="zs-radio" style="display: flex; align-items: center;">
              <input type="radio" name="contractDetailsValueFormat" [(ngModel)]="selectedContractDetailsMultiplier" [value]="1000000">
              <span radio style="padding-right: 1rem;">Millions</span>
            </label>
            
            <div style="border-left: 1px solid #ccc; height: 1.5rem;"></div>


            <label class="zs-radio" style="display: flex; align-items: center;">
              <input type="radio" name="contractDetailsDecimal" [(ngModel)]="contractDetailsDecimalFormat" value="1.0-0" />
              <span radio style="padding-right: 0.75rem;">0&nbsp;Decimals</span>
            </label>
            <label class="zs-radio" style="display: flex; align-items: center;">
              <input type="radio" name="contractDetailsDecimal" [(ngModel)]="contractDetailsDecimalFormat" value="1.1-1" />
              <span radio style="padding-right: 0.75rem;">1&nbsp;Decimal</span>
            </label>
            <label class="zs-radio" style="display: flex; align-items: center;">
              <input type="radio" name="contractDetailsDecimal" [(ngModel)]="contractDetailsDecimalFormat" value="1.2-2" />
              <span radio style="padding-right: 0.75rem;">2&nbsp;Decimals</span>
            </label>
            
          </div>

          <div class="copy-clipboard" style="margin-right: 20px;padding-top: 1rem;">
            <span>
              <a href="javascript:void(0)" title="Copy to Clipboard" (click)="copyToExcel('scenarioComparisonContractDetails', true)"
                class="zs-icon zs-size-xl zs-icon-note"></a>
              <a href="javascript:void(0)" (click)="copyToExcel('scenarioComparisonContractDetails', true)">Copy</a>
            </span>
          </div>
        </div>
        <div *ngIf="!showDiv" class="scenario-comparison__calculation-table zs-padding-0-0-2-0 table">
          <table class="zs-table zs-table-condense cds-sticky-table-column-first">
            <thead>
              <tr>
                <th class="fixed-width-column">Metrics</th>
                <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
                  <th class="zs-text-align-right" *ngIf="row == 0">{{scenario.scenario_name}} </th>
                  <th class="zs-text-align-right" *ngIf="row != 0">{{scenario.scenario_name}} </th>
                </ng-container>

              </tr>

            </thead>
            <tbody>
              <ng-container *ngFor="let scenario of contractDetailsData[selectedContractIndex].data; let index = index;">

                  <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'Contract_subScenarioName'}">
                    <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'Contract_subScenarioName'}">
                      {{ scenario.Item_Text }}
                      <span *ngIf="checkContractDetailsSubProductInputTabDiscountSummary(selectedContractIndex, index)">
                        <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                          <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                        </a>
                      </span>
                    </td>
                    <ng-container *ngFor="let item of scenario.data">
                    <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                      <ng-container *ngIf="scenario.Item_Text === 'Lives'"> 
                        {{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedContractDetailsMultiplier) | number :
                        contractDetailsDecimalFormat) }}
                      </ng-container>
                      <ng-container *ngIf="scenario.Item_Text !== 'Lives'">
                        {{ (item === "-" || item * 1 != item * 1) ? item : (item | number : '1.2-2') }}
                      </ng-container>
                    </td>
                    </ng-container>
                  </tr>

                <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkContractDetailsSubProductInputTabDiscountSummary(selectedContractIndex, index)" >

                  <ng-container *ngFor="let subRowObj of subContractDetailsConfigurationDiscountSummary[selectedContractIndex]['data'][index]">

                    <tr *ngIf="subRowObj.Is_Submetric == 'Yes'" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                      <td class="zs-display-none "></td>
                      <td class="sticky-product-column-first fixed-width-column" > &nbsp; - {{ subRowObj.Item_Text }}</td>

                      <ng-container *ngFor="let value of subRowObj.data">
                        <td class="zs-text-align-right">
                          <ng-container *ngIf="subRowObj.Item_Text === 'Lives'">
                            {{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedContractDetailsMultiplier) | number : contractDetailsDecimalFormat) }}
                          </ng-container>
                          <ng-container *ngIf="subRowObj.Item_Text !== 'Lives'">
                            {{ (value === "-" || value * 1 != value * 1) ? value : (value | number : '1.2-2') }}
                          </ng-container>
                        </td>
                      </ng-container>
                    </tr>

                  </ng-container>


                </ng-container>


              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Contract Financials  -->
      <div>
        <div *ngIf="!showDiv" style="font-weight: bold; text-align: left; margin: 20px 0 10px; font-size: 18px;">
          Contract Financials
        </div>
        <div *ngIf="!showDiv" class="zs-display-flex zs-margin-1-0"
        style="display: flex; justify-content: normal; align-items: center; ">
        <!--Dropdown and Copy for Customer POV -->
        <div class="filter zs-text-align-left" style="margin-right: 20px;">
          <p-is-zs-select #brandDpDwn *ngIf="productList?.length>0" class="zs-action-field zs-select" mode="action"
              hide-on-scroll label="Selected Product"
              (change)="selectedProductName = brandDpDwn.getValue(); getFinancialindex(selectedProductName); checkFinancialPCGCMetrics()"
              clear>
              <select>
                  <option *ngFor="let brand of productList" [value]="brand">{{brand}} </option>
              </select>
          </p-is-zs-select>
        </div>
        <div class="bordered1" style="display: flex; align-items: center; flex-wrap: nowrap; gap: 1rem; margin-right: auto;">
          
          <label class="zs-radio" style="display: flex; align-items: center;">
            <input type="radio" name="ContractFinancialValues" [(ngModel)]="selectedContractFinancialMultiplier" [value]="1">
            <span radio style="padding-right: 1rem;">Actuals</span>
          </label>
          <label class="zs-radio" style="display: flex; align-items: center;">
            <input type="radio" name="ContractFinancialValues" [(ngModel)]="selectedContractFinancialMultiplier" [value]="1000">
            <span radio style="padding-right: 1rem;">Thousands</span>
          </label>
          <label class="zs-radio" style="display: flex; align-items: center;">
            <input type="radio" name="ContractFinancialValues" [(ngModel)]="selectedContractFinancialMultiplier" [value]="1000000">
            <span radio style="padding-right: 1rem;">Millions</span>
          </label>
          
          <div style="border-left: 1px solid #ccc; height: 1.5rem;"></div>

          <label class="zs-radio" style="display: flex; align-items: center;">
            <input type="radio" name="contractDecimalFormat" [(ngModel)]="contractDecimalFormat" value="1.0-0" />
            <span radio style="padding-right: 0.75rem;">0&nbsp;Decimals</span>
          </label>
          <label class="zs-radio" style="display: flex; align-items: center;">
            <input type="radio" name="contractDecimalFormat" [(ngModel)]="contractDecimalFormat" value="1.1-1" />
            <span radio style="padding-right: 0.75rem;">1&nbsp;Decimal</span>
          </label>
          <label class="zs-radio" style="display: flex; align-items: center;">
            <input type="radio" name="contractDecimalFormat" [(ngModel)]="contractDecimalFormat" value="1.2-2" />
            <span radio style="padding-right: 0.75rem;">2&nbsp;Decimals</span>
          </label>
        </div>

        <div class="copy-clipboard" style="margin-right: 20px;padding-top: 1rem;">
          <span>
            <a href="javascript:void(0)" title="Copy to Clipboard" (click)="copyToExcel('scenarioComparisonContractFinancials', true)"
              class="zs-icon zs-size-xl zs-icon-note"></a>
            <a href="javascript:void(0)" (click)="copyToExcel('scenarioComparisonContractFinancials', true)">Copy</a>
          </span>
        </div>
        </div>
        <div *ngIf="!showDiv" class="scenario-comparison__calculation-table zs-padding-0-0-2-0 table">
          <table class="zs-table zs-table-condense cds-sticky-table-column-first">
            <thead>
                <tr>
                    <th class="fixed-width-column">Metrics</th>
                    <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
                      <th class="zs-text-align-right" *ngIf="row == 0">{{scenario.scenario_name}}  </th>
                      <th class="zs-text-align-right" *ngIf="row != 0">{{scenario.scenario_name}}  </th>
                    </ng-container>

                </tr>

            </thead>
            <tbody>
              <ng-container *ngIf="povCommonDdbSummary.timeCategory.selected =='Total Contract Period'">
                <ng-container *ngFor="let scenario of financialData[selectedFinancialindex].financialData; let index = index;">

                    <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                      <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                        {{ scenario.Item_Text }}
                        <span *ngIf="checkFinancialSubProductInputTabDiscountSummary(selectedFinancialindex, index)">
                          <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                            <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                          </a>
                        </span>
                      </td>
                      <ng-container *ngFor="let item of scenario.data">
                        <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">{{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedContractFinancialMultiplier) | number :  contractDecimalFormat) }}</td>
                      </ng-container>
                    </tr>

                    <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkFinancialSubProductInputTabDiscountSummary(selectedFinancialindex, index)" >

                      <ng-container *ngFor="let subRowObj of subContractFinancialConfigurationDiscountSummary[selectedFinancialindex]['financialData'][index]">

                        <tr *ngIf="subRowObj.Is_Submetric == 'Yes' && checkSubMetricVisiblity(subRowObj.lineItem,financialData[selectedFinancialindex].financialData)" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                          <td class="zs-display-none "></td>
                          <td class="sticky-product-column-first fixed-width-column" >&nbsp; - {{ subRowObj.Item_Text }}</td>

                          <ng-container *ngFor="let value of subRowObj.data">
                            <td class="zs-text-align-right">{{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedContractFinancialMultiplier) | number :  contractDecimalFormat) }}</td>
                          </ng-container>
                        </tr>

                      </ng-container>


                    </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="povCommonDdbSummary.timeCategory.selected =='Calendar Year'">
                <ng-container *ngFor="let scenario of financialData[selectedFinancialindex].financialData; let index = index;">

                    <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                      <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                        {{ scenario.Item_Text }}
                        <span *ngIf="checkFinancialSubProductInputTabDiscountSummary(selectedFinancialindex, index)">
                          <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                            <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                          </a>
                        </span>
                      </td>
                      <ng-container *ngFor="let yearObj of scenario.yearlyDataView">
                          <ng-container *ngIf="yearObj.year === +selectedyear">
                            <ng-container *ngFor="let item of yearObj.data">
                              <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                                {{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedContractFinancialMultiplier) | number : contractDecimalFormat) }}
                              </td>
                            </ng-container>
                          </ng-container>
                        </ng-container>

                    </tr>

                    <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkFinancialSubProductInputTabDiscountSummary(selectedFinancialindex, index)" >

                      <ng-container *ngFor="let subRowObj of subContractFinancialConfigurationDiscountSummary[selectedFinancialindex]['financialData'][index]">

                        <tr *ngIf="subRowObj.Is_Submetric == 'Yes' && checkSubMetricVisiblity(subRowObj.lineItem,financialData[selectedFinancialindex].financialData)" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                          <td class="zs-display-none "></td>
                          <td class="sticky-product-column-first fixed-width-column" >&nbsp; - {{ subRowObj.Item_Text }}</td>

                          <ng-container *ngFor="let yearObj of subRowObj.yearlyDataView">
                            <ng-container *ngIf="yearObj.year === +selectedyear">
                            <ng-container *ngFor="let value of yearObj.data">
                            <td class="zs-text-align-right">{{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedContractFinancialMultiplier) | number :  contractDecimalFormat) }}</td>
                            </ng-container>
                            </ng-container>
                          </ng-container>
                        </tr>

                      </ng-container>


                    </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
<!-- Breakeven Metrics -->
<div *ngIf="resources.BreakevenR3.Visible=='Y'">
  <div *ngIf="!showDiv" style="font-weight: bold; text-align: left; margin: 20px 0 10px; font-size: 18px;">
    Breakeven Metrics
  </div>
  <div *ngIf="!showDiv" class="zs-display-flex zs-margin-1-0"
    style="display: flex; justify-content: space-between; align-items: center; ">
    <!--Dropdown and Copy for Breakeven Metrics -->
    <div class="filter zs-text-align-left" style="margin-right: 20px;">
      <p-is-zs-select #breakevenDpDwn *ngIf="breakevenProdList?.length>0" class="zs-action-field zs-select" mode="action"
          hide-on-scroll label="Selected Product"
          (change)="selectedBreakevenProductName = breakevenDpDwn.getValue(); getBreakevenindex(selectedBreakevenProductName);"
          clear>
          <select>
              <option *ngFor="let brand of breakevenProdList" [value]="brand">{{brand}} </option>
          </select>
      </p-is-zs-select>
    </div>

    <div class="copy-clipboard" style="margin-right: 20px;padding-top: 1rem;">
      <span>
        <a href="javascript:void(0)" title="Copy to Clipboard" (click)="copyToExcel('scenarioComparisonBreakevenMetrics', true)"
          class="zs-icon zs-size-xl zs-icon-note"></a>
        <a href="javascript:void(0)" (click)="copyToExcel('scenarioComparisonBreakevenMetrics', true)">Copy</a>
      </span>
    </div>
  </div>
  
  <div *ngIf="!showDiv" class="scenario-comparison__breakeven-metrics zs-padding-0-0-2-0 table">
    <table class="zs-table zs-table-condense cds-sticky-table-column-first">
      <thead>
        <tr>
          <th class="fixed-width-column">Metrics</th>
          <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
            <th class="zs-text-align-right">{{scenario.scenario_name}}</th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
  <tr *ngFor="let row of breakevenData[selectedBreakevenindex]?.data" [ngClass]="{'zs-bg-surface-2': row.lineItem === 'subScenarioName'}">
    <ng-container *ngIf="row.isSectionHeader">
      <td [attr.colspan]="comparisonOutputGrid.length + 1" class="zs-font-weight-bold zs-bg-surface-2">
        {{ row.Item_Text }}
      </td>
    </ng-container>
    <ng-container *ngIf="!row.isSectionHeader && row.isSelected">
      <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': row.lineItem === 'subScenarioName'}">{{ row.Item_Text }}</td>
      <ng-container *ngFor="let item of row.data">
        <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': row.lineItem === 'subScenarioName'}">{{ item }}</td>
      </ng-container>
    </ng-container>
  </tr>
</tbody>
    </table>
  </div>
</div>

  <!-- Customer POV  -->
  <div>
    <div *ngIf="!showDiv" style="font-weight: bold; text-align: left; margin: 20px 0 10px; font-size: 18px;">
      Customer POV
    </div>
    <div *ngIf="!showDiv" class="zs-display-flex zs-margin-1-0"
      style="display: flex; justify-content: normal; align-items: center; ">
      <!--Dropdown and Copy for Customer POV -->
      <div class="filter zs-text-align-left" style="margin-right: 20px;">
        <p-is-zs-select #CustomerDpDwn *ngIf="customerProdList?.length > 0" class="zs-action-field zs-select"
          mode="action" hide-on-scroll label="Selected Product"
          (change)="selectedCustomerProductName = CustomerDpDwn.getValue(); getCustomerindex(selectedCustomerProductName); checkCustomerPCGCMetrics();"
          clear>
          <select>
            <option *ngFor="let customerProduct of customerProdList" [value]="customerProduct">{{customerProduct}}
            </option>
          </select>
        </p-is-zs-select>
      </div>
      <div class="bordered1" style="display: flex; align-items: center; flex-wrap: nowrap; gap: 1rem; margin-right: auto;">
       
        <label class="zs-radio"  style="display: flex; align-items: center;">
          <input type="radio" name="customerPovValues" [(ngModel)]="selectedCusPovMultiplier" [value]="1">
          <span radio style="padding-right: 1rem;">Actuals</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="customerPovValues" [(ngModel)]="selectedCusPovMultiplier" [value]="1000">
          <span radio style="padding-right: 1rem;">Thousands</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="customerPovValues" [(ngModel)]="selectedCusPovMultiplier" [value]="1000000">
          <span radio style="padding-right: 1rem;">Millions</span>
        </label>
        
        <div style="border-left: 1px solid #ccc; height: 1.5rem;"></div>


        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="customerPovDecimal" [(ngModel)]="customerDecimalFormat" value="1.0-0" />
          <span radio style="padding-right: 0.75rem;">0&nbsp;Decimals</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="customerPovDecimal" [(ngModel)]="customerDecimalFormat" value="1.1-1" />
          <span radio style="padding-right: 0.75rem;">1&nbsp;Decimal</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="customerPovDecimal" [(ngModel)]="customerDecimalFormat" value="1.2-2" />
          <span radio style="padding-right: 0.75rem;">2&nbsp;Decimals</span>
        </label>
        
      </div>

      <div class="copy-clipboard" style="margin-right: 20px;padding-top: 1rem;">
        <span>
          <a href="javascript:void(0)" title="Copy to Clipboard" (click)="copyToExcel('scenarioComparisonCustomerPOV', true)"
            class="zs-icon zs-size-xl zs-icon-note"></a>
          <a href="javascript:void(0)" (click)="copyToExcel('scenarioComparisonCustomerPOV', true)">Copy</a>
        </span>
      </div>
    </div>
    <div *ngIf="!showDiv" class="scenario-comparison__calculation-table zs-padding-0-0-2-0 table">
      <table class="zs-table zs-table-condense cds-sticky-table-column-first">
        <thead>
          <tr>
            <th class="fixed-width-column">Metrics</th>
            <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
              <th class="zs-text-align-right" *ngIf="row == 0">{{scenario.scenario_name}} </th>
              <th class="zs-text-align-right" *ngIf="row != 0">{{scenario.scenario_name}} </th>
            </ng-container>

          </tr>

        </thead>
        <tbody>
          <ng-container *ngIf="povCommonDdbSummary.timeCategory.selected === 'Total Contract Period'">
          <ng-container *ngFor="let scenario of customerPOVData[selectedCustomerindex].data; let index = index;">

              <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                  {{ scenario.Item_Text }}
                  <span *ngIf="checkCustomerFinancialSubProductInputTabDiscountSummary(selectedCustomerindex, index)">
                    <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                      <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                    </a>
                  </span>
                </td>
                <ng-container *ngFor="let item of scenario.data">
                  <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">{{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedCusPovMultiplier) | number : customerDecimalFormat) }}</td>
                </ng-container>
              </tr>

            <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkCustomerFinancialSubProductInputTabDiscountSummary(selectedCustomerindex, index)" >

              <ng-container *ngFor="let subRowObj of subCustomerPOVConfigurationDiscountSummary[selectedCustomerindex]['data'][index]">

                <tr *ngIf="subRowObj.Is_Submetric == 'Yes' && checkSubMetricVisiblity(subRowObj.lineItem,customerPOVData[selectedCustomerindex].data)" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                  <td class="zs-display-none "></td>
                  <td class="sticky-product-column-first fixed-width-column" > &nbsp; - {{ subRowObj.Item_Text }}</td>

                  <ng-container *ngFor="let value of subRowObj.data">
                    <td class="zs-text-align-right">{{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedCusPovMultiplier) | number : customerDecimalFormat) }}</td>
                  </ng-container>
                </tr>

              </ng-container>


            </ng-container>


          </ng-container>
          </ng-container>
          <ng-container *ngIf="povCommonDdbSummary.timeCategory.selected === 'Calendar Year'">
          <ng-container *ngFor="let scenario of customerPOVData[selectedCustomerindex].data; let index = index;">

              <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                  {{ scenario.Item_Text }}
                  <span *ngIf="checkCustomerFinancialSubProductInputTabDiscountSummary(selectedCustomerindex, index)">
                    <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                      <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                    </a>
                  </span>
                </td>
                <ng-container *ngFor="let yearObj of scenario.yearlyDataView">
                  <ng-container *ngIf="yearObj.year === +selectedyear">
                  <ng-container *ngFor="let item of yearObj.data">
                    <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                      {{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedCusPovMultiplier) | number : customerDecimalFormat) }}
                    </td>
                  </ng-container>
                  </ng-container>
                </ng-container>
              </tr>

            <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkCustomerFinancialSubProductInputTabDiscountSummary(selectedCustomerindex, index)" >

              <ng-container *ngFor="let subRowObj of subCustomerPOVConfigurationDiscountSummary[selectedCustomerindex]['data'][index]">

                <tr *ngIf="subRowObj.Is_Submetric == 'Yes' && checkSubMetricVisiblity(subRowObj.lineItem,customerPOVData[selectedCustomerindex].data)" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                  <td class="zs-display-none "></td>
                  <td class="sticky-product-column-first fixed-width-column" > &nbsp; - {{ subRowObj.Item_Text }}</td>

                  <ng-container *ngFor="let yearObj of subRowObj.yearlyDataView">
                  <ng-container *ngIf="yearObj.year === +selectedyear">
                    <ng-container *ngFor="let value of yearObj.data">
                      <td class="zs-text-align-right">
                        {{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedCusPovMultiplier) | number : customerDecimalFormat) }}
                      </td>
                    </ng-container>
                  </ng-container>
                  </ng-container>
                </tr>

              </ng-container>


            </ng-container>


          </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <!-- Competitor POV  -->
  <div>
    <div *ngIf="!showDiv" style="font-weight: bold; text-align: left; margin: 20px 0 10px; font-size: 18px;">
      Competitor POV
    </div>
    <div *ngIf="!showDiv" class="zs-display-flex zs-margin-1-0"
      style="display: flex; justify-content: normal; align-items: center; ">
      <!--Dropdown and Copy for Competitor -->
      <div class="filter zs-text-align-left" style="margin-right: 20px;" >
        <p-is-zs-select #CompetitorDpDwn *ngIf="compProdList?.length > 0" class="zs-action-field zs-select"
          mode="action" hide-on-scroll label="Selected Competitor Product"
          (change)="selectedCompetitorProductName = CompetitorDpDwn.getValue(); getCompetitorindex(selectedCompetitorProductName); checkCompetitorMetrics()"
          clear>
          <select>
            <option *ngFor="let competitorProduct of compProdList" [value]="competitorProduct">{{competitorProduct}}
            </option>
          </select>
        </p-is-zs-select>
      </div>

      <div class="bordered1" style="display: flex; align-items: center; flex-wrap: nowrap; gap: 1rem; margin-right: auto;">
       
        <label class="zs-radio"  style="display: flex; align-items: center;">
          <input type="radio" name="compPovValues" [(ngModel)]="selectedMultiplier" [value]="1">
          <span radio style="padding-right: 1rem;">Actuals</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="compPovValues"  [(ngModel)]="selectedMultiplier" [value]="1000">
          <span radio style="padding-right: 1rem;">Thousands</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="compPovValues" [(ngModel)]="selectedMultiplier" [value]="1000000">
          <span radio style="padding-right: 1rem;">Millions</span>
        </label>
        <div style="border-left: 1px solid #ccc; height: 1.5rem;"></div>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="competitorDecimalFormat" [(ngModel)]="competitorDecimalFormat" value="1.0-0" />
          <span radio style="padding-right: 0.75rem;">0&nbsp;Decimals</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="competitorDecimalFormat" [(ngModel)]="competitorDecimalFormat" value="1.1-1" />
          <span radio style="padding-right: 0.75rem;">1&nbsp;Decimal</span>
        </label>
        <label class="zs-radio" style="display: flex; align-items: center;">
          <input type="radio" name="competitorDecimalFormat" [(ngModel)]="competitorDecimalFormat" value="1.2-2" />
          <span radio style="padding-right: 0.75rem;">2&nbsp;Decimals</span>
        </label>
      </div>
      <div class="copy-clipboard" style="margin-right: 20px;padding-top: 1rem;">
        <span>
          <a href="javascript:void(0)" title="Copy to Clipboard" (click)="copyToExcel('scenarioComparisonCompetitorPOV', true)"
            class="zs-icon zs-size-xl zs-icon-note"></a>
          <a href="javascript:void(0)" (click)="copyToExcel('scenarioComparisonCompetitorPOV', true)">Copy</a>
        </span>
      </div>
    </div>
    <div *ngIf="!showDiv" class="scenario-comparison__calculation-table zs-padding-0-0-2-0 table">
      <table class="zs-table zs-table-condense cds-sticky-table-column-first">
        <thead>
          <tr>
            <th class="fixed-width-column">Metrics</th>
            <ng-container *ngFor="let scenario of comparisonOutputGrid; let row = index;">
              <th class="zs-text-align-right" *ngIf="row == 0">{{scenario.scenario_name}} </th>
              <th class="zs-text-align-right" *ngIf="row != 0">{{scenario.scenario_name}} </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>        
          <ng-container  *ngIf="povCommonDdbSummary.timeCategory.selected === 'Total Contract Period'">
          <ng-container *ngFor="let scenario of compPOVData[selectedCompetitorIndex].data; let index = index;">
            <!-- Main Metric Row -->
            <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
              <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                {{ scenario.Item_Text }}
                <span *ngIf="checkSubProductInputTabDiscountSummary(selectedCompetitorIndex, index)">
                  <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                    <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                  </a>
                </span>
              </td>
              <ng-container *ngFor="let item of scenario.data">
                <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">{{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedMultiplier) | number : competitorDecimalFormat) }}</td>
              </ng-container>
            </tr>


            <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkSubProductInputTabDiscountSummary(selectedCompetitorIndex, index)" >

              <ng-container *ngFor="let subRowObj of subFinancialConfigurationDiscountSummary[selectedCompetitorIndex]['data'][index]">

                <tr *ngIf="subRowObj.Is_Submetric == 'Yes' && checkSubMetricVisiblity(subRowObj.lineItem,compPOVData[selectedCompetitorIndex].data)" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                  <td class="zs-display-none "></td>
                  <td class="sticky-product-column-first fixed-width-column" > &nbsp;- {{ subRowObj.Item_Text }}</td>

                  <ng-container *ngFor="let value of subRowObj.data">
                    <td class="zs-text-align-right">{{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedMultiplier) | number : competitorDecimalFormat) }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </ng-container>
          <ng-container *ngIf="povCommonDdbSummary.timeCategory.selected === 'Calendar Year'">
          <ng-container *ngFor="let scenario of compPOVData[selectedCompetitorIndex].data; let index = index;">
            <!-- Main Metric Row -->
            <tr *ngIf="scenario.Is_Submetric === 'No' && scenario.isSelected === true" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
              <td class="fixed-width-column" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                {{ scenario.Item_Text }}
                <span *ngIf="checkSubProductInputTabDiscountSummary(selectedCompetitorIndex, index)">
                  <a (click)="toggleAccordian($event)" href="javascript:void(0)">
                    <span class="zs-icon zs-size-xl zs-icon-carat-down"></span>
                  </a>
                </span>
              </td>
              <ng-container *ngFor="let yearObj of scenario.yearlyDataView">
              <ng-container *ngIf="yearObj.year === +selectedyear">
                <ng-container *ngFor="let item of yearObj.data">
                  <td class="zs-text-align-right" [ngClass]="{'zs-bg-surface-2': scenario.lineItem === 'subScenarioName'}">
                    {{ (item === "-" || item * 1 != item * 1) ? item : ((item / selectedMultiplier) | number : competitorDecimalFormat) }}
                  </td>
                </ng-container>
              </ng-container>
              </ng-container>
            </tr>


            <ng-container *ngIf="scenario.isSelected === true && scenario.Is_Submetric == 'No' && checkSubProductInputTabDiscountSummary(selectedCompetitorIndex, index)" >

              <ng-container *ngFor="let subRowObj of subFinancialConfigurationDiscountSummary[selectedCompetitorIndex]['data'][index]">

                <tr *ngIf="subRowObj.Is_Submetric == 'Yes' && checkSubMetricVisiblity(subRowObj.lineItem,compPOVData[selectedCompetitorIndex].data)" colspan="100%" class="zs-bg-surface-2 zs-display-none" style="padding: 0px; border: none;" >
                  <td class="zs-display-none "></td>
                  <td class="sticky-product-column-first fixed-width-column" > &nbsp;- {{ subRowObj.Item_Text }}</td>

                  <ng-container *ngFor="let yearObj of subRowObj.yearlyDataView">
                  <ng-container *ngIf="yearObj.year === +selectedyear">
                    <ng-container *ngFor="let value of yearObj.data">
                      <td class="zs-text-align-right">
                        {{ (value === "-" || value * 1 != value * 1) ? value : ((value / selectedMultiplier) | number : competitorDecimalFormat) }}
                      </td>
                    </ng-container>
                  </ng-container>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </ng-container> 
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- add scenario modal -->
<zs-dialog modal class="zs-dialog modal" #addScenarioRef role="dialog">
  <header>
    <span close="" onclick="this.parentNode.parentNode.close()">
      <a href="javascript:;" class="zs-icon zs-icon-close-circle-fill zs-size-xl"></a>
    </span>
  </header>
  <section class="comparison-inputs" [appLoading]="isModalLoading" [loaderColor]='loaderSelector'>
    <div class="comparison-inputs__filters">
      <div class="search">
        <p-is-zs-action-field class="search__search-box zs-action-field zs-action-field-solid zs-border" type="text"
          placeholder="Search..." [(ngModel)]="searchComparisonScenarios" (input)="onSearchInput()"
          autocomplete="off" icon="search" action-icon="collapse" ngDefaultControl>
        </p-is-zs-action-field>

      </div>
      <div class="filter">
        <p-is-zs-select #brandDpDwn *ngIf="brandList?.length>0" class="zs-action-field zs-select" mode="action"
          hide-on-scroll label="Product:"
          (change)="selectedBrandName = brandDpDwn.getValue(); getFilteredScenarios(null); resetSelectedScenarioCount();"
          clear>
          <select>
            <option *ngFor="let brand of brandList" [value]="brand">{{brand}} </option>
          </select>
        </p-is-zs-select>
      </div>
      <div class="filter">
        <p-is-zs-select #channelDpDwn *ngIf="ChannelList?.length>0" class="zs-action-field zs-select" mode="action"
          hide-on-scroll label="Channel:"
          (change)="selectedChannel = channelDpDwn.getValue(); getFilteredScenarios(null); resetSelectedScenarioCount();"
          clear>
          <select>
            <option *ngFor="let channel of ChannelList" [value]="channel">{{channel}} </option>
          </select>
        </p-is-zs-select>
      </div>
    </div>
    <div class="comparison-inputs__table">
      <div class="counter-text">No. of selected scenarios for selected Brand and Channel :
        {{counterForCheckedScenariosCount}} max {{maxCheckedScenarios}}</div>
      <table class="zs-table zs-table-condense">
        <thead>
          <tr>
            <th>Add</th>
            <th>Scenarios</th>
            <th>Project Name</th>
            <th>Brand</th>
            <th>Channel</th>
            <th>Project Owner</th>
            <th>Modified Date</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let scenario of scenarioListForComparison">
            <tr>
              <td>
                <label class="zs-checkbox"
                  [ngClass]="{'zs-disabled': (scenario.checkedForComparison == false && counterForCheckedScenariosCount >= maxCheckedScenarios)}">
                  <input type="checkbox" [(ngModel)]="scenario.checkedForComparison"
                    (change)=counterForCheckedScenarios(scenario)><span checkbox></span>
                </label>
              </td>
              <td>{{scenario.ScenarioName}}</td>
              <td>{{scenario.ProjectName}}</td>
              <td>{{scenario.BrandName}}</td>
              <td>{{scenario.Channel}}</td>
              <td>{{scenario.ProjectOwner}}</td>
              <td>{{scenario.DateModified| date:'dd MMM yyyy'}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="comparison-inputs__pagination">
      <span id="pagination-status">Showing {{(paginationOptions.currentPage - 1)*paginationOptions.pageSize +
        1}}-{{(paginationOptions.currentPage*paginationOptions.pageSize)>paginationOptions.itemsCount?paginationOptions.itemsCount:(paginationOptions.currentPage*paginationOptions.pageSize)}}
        of
        {{paginationOptions.itemsCount}}&nbsp;&nbsp;&nbsp;</span>
      <zs-pagination (pagechange)="pageChange($event)" *ngIf="paginationOptions?.itemsCount > 0" class="zs-pagination"
        mode="action" [itemsCount]="paginationOptions.itemsCount"
        [maxDisplayPages]="paginationOptions.maxDisplayPages" [pageSize]="paginationOptions.pageSize"
        [currentPage]="paginationOptions?.currentPage">
      </zs-pagination>
    </div>
  </section>
  <footer class="footer">
    <a class="footer__cancel-btn zs-button zs-border-rounded-0" href="javascript:;"
      onclick="this.parentNode.parentNode.close()">Cancel</a>
    <button class="zs-button zs-button-action zs-border-rounded-0"
      (click)="confirmScenarioComparison()">Confirm</button>
  </footer>
</zs-dialog>
</div>